import React, { useEffect, useState } from "react";
import {
  ArcElement,
  Chart as ChartJS,
  Legend,
  Tooltip,
  LineElement,
  CategoryScale,
  Title,
  LinearScale,
  PointElement,
  Filler, // 1. Import Filler plugin
} from "chart.js";
import { Line } from "react-chartjs-2";
import { connect } from "react-redux";
import { GetCostChart } from "../../../../redux/actions/adminActions";
import { toast } from "react-toastify";
import { Col, Row, Select } from "antd";
import "./chart.css";
import moment from "moment";

const { Option } = Select;

const CostChart = (props) => {
  const [costYear, setCostYear] = useState(null);

  const { GetCostChart, cost_chart } = props;

  // Chart
  ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Filler,
    Title
  );
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const getCostInventoryRecords = async () => {
    const res = await GetCostChart(costYear);
    if (!res.success) {
      toast.error(`Error`);
    }
  };
  useEffect(() => {
    if (costYear) {
      getCostInventoryRecords();
    }
  }, [costYear]);

  const cost_data = {
    labels: cost_chart ? Object?.keys(cost_chart) : [],
    datasets: [
      {
        label: "Costs",
        data: cost_chart ? Object?.values(cost_chart) : [],
        borderColor: "#0A4C3E",
        color: "#777777",
        fill: true, // Fill the area under the line
        tension: 0.4,
      },
    ],
  };

  const checkOnchange = (value) => {
    setCostYear(value);
  };

  const years = ["2024", JSON.stringify(moment().year())];
  const yearChildren = years?.map((obj) => {
    return (
      <Option key={obj} value={obj}>
        {obj}
      </Option>
    );
  });

  useEffect(() => {
    setCostYear(JSON.stringify(moment().year()));
  }, []);
  return (
    <div className="chart-container">
      <div className="chart-item">
        <Row gutter={24}>
          <Col xs={24} xl={12} lg={12}>
            <h6>Cost Inventory</h6>
          </Col>
          <Col xs={24} xl={12} lg={12}>
            <Row gutter={24}>
              <Col xs={24} xl={24} lg={24}>
                <Select
                  name="cost-year"
                  placeholder="Select year"
                  size="medium"
                  value={costYear}
                  onChange={(event) => checkOnchange(event)}
                  className="select"
                >
                  {yearChildren}
                </Select>
              </Col>
            </Row>
          </Col>
        </Row>
        <div style={{ height: "200px", marginTop: "20px" }}>
          <Line options={options} data={cost_data} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cost_chart: state.adminReducer.cost_chart,
  };
};

export default connect(mapStateToProps, {
  GetCostChart,
})(CostChart);
